import React from 'react';
import { DollarSignIcon, TargetIcon } from 'lucide-react';
export function CostAndFormat() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3418">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3419">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-3420">
          <div className="bg-white rounded-xl p-6 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3421">
            <div className="flex items-center gap-3 mb-4" data-id="element-3422">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{
              backgroundColor: 'rgba(30,61,47,0.08)'
            }} data-id="element-3423">
                <DollarSignIcon size={20} style={{
                color: '#1e3d2f'
              }} data-id="element-3424" />
              </div>
              <h3 className="text-lg font-bold uppercase" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#1e3d2f'
            }} data-id="element-3425">
                Cost
              </h3>
            </div>
            <p className="text-base" style={{
            color: '#2a2a2a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3426">
              <strong data-id="element-3427">$20</strong> for the first gun and <strong data-id="element-3428">$5</strong> for
              every additional gun.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3429">
            <div className="flex items-center gap-3 mb-4" data-id="element-3430">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{
              backgroundColor: 'rgba(30,61,47,0.08)'
            }} data-id="element-3431">
                <TargetIcon size={20} style={{
                color: '#1e3d2f'
              }} data-id="element-3432" />
              </div>
              <h3 className="text-lg font-bold uppercase" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#1e3d2f'
            }} data-id="element-3433">
                Match Format
              </h3>
            </div>
            <p className="text-base" style={{
            color: '#2a2a2a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3434">
              There will be <strong data-id="element-3435">5 stages</strong> run in{' '}
              <strong data-id="element-3436">4 bays</strong>.
            </p>
          </div>
        </div>
      </div>
    </div>;
}